import {FC, Card, PropsWithChildren, Button} from 'external/react'
import Icon from 'external/fortawesome'

import { offerService} from 'services/offer.service'
import { notifySuccess } from 'components/Notify'
import useAdmin from 'context/admin-context/hook'
import ButtonBack from 'components/ButtonBack'
import BasicLayout from './BasicLayout'

const AdminOfferConfigurationContainer: FC<PropsWithChildren> = props => {
    const {children} = props
    const {currentOffer, validate, errors} = useAdmin()

    async function handleSaveOffer() {
        console.log(validate(currentOffer, true), errors)
        if (!validate(currentOffer, true)) return
        await offerService.updateOffer(currentOffer)
        notifySuccess('Oferta actualizada exitosamente.')
	}

    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path='/admin/offers' />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name='faBox' /> Configuración de oferta
                </div>
                <div style={{ fontSize: '16px' }} className='d-flex flex-grow-1 justify-content-end align-items-center'>
                    <Button onClick={handleSaveOffer} >Guardar</Button>
                </div>
            </Card.Header> 
            {children}
        </BasicLayout>
    )
}

export {AdminOfferConfigurationContainer as default}